import { ClockCircleOutlined } from '@ant-design/icons';
import { Skeleton, Timeline } from 'antd';
import Markdown from 'react-markdown';
import { OpenaiMessageInHistory } from '../StoryPage';

export const StoryMainMessageHistory = (props: { qStory: any; storyId: number }) => {
  const story = props.qStory.data?.StoryController_getStoryById || {};
  if (props.qStory.loading || !story) {
    return <Skeleton active />;
  }

  if (!story.messageHistory) {
    return <div>Story message history is empty</div>;
  }

  return (
    <Timeline
      items={(story.messageHistory || []).map((item: OpenaiMessageInHistory, index: number) => {
        const color = item.role === 'system' ? 'green' : item.role === 'assistant' ? 'blue' : 'gray';

        return {
          key: index,
          children: <Markdown>{item.content}</Markdown>,
          color: color,
          dot: <ClockCircleOutlined style={{ color: color }} />,
        };
      })}
    />
  );
};
